export default __webpack_public_path__ + "static/media/pin-blu.14bfb36a.svg";